/// <amd-module name="VSS/Features/Charts/BubbleChart" />
import * as React from "react";
import * as Charts_Contracts from "VSS/Features/Charts/Contracts";
import { AxialChartImplementation } from "VSS/Features/Charts/Internal/AxialChartImplementations";
import { ChartTypesRegistry } from "VSS/Features/Charts/Internal/ChartTypesRegistry";
import { HighchartsExtendedPointObject } from "VSS/Features/Charts/Internal/InternalContracts";
import * as Charts_Resources from "VSS/Features/Charts/Resources";

import { BubbleChartTabularComponent } from "./BubbleChartTabularComponent";

export interface BubbleChartExtendedPointObject extends HighchartsExtendedPointObject {
    z?: number;
}

export class BubbleChart extends AxialChartImplementation {
    public getTabularComponent(chartOptions: Charts_Contracts.ChartProps): JSX.Element {
        return React.createElement(BubbleChartTabularComponent, chartOptions);
    }

    public interpretPointAsValuesForTooltip(point: BubbleChartExtendedPointObject): (string | number)[] {
        const yAxisCategories = point.series.yAxis.categories;
        if (yAxisCategories && yAxisCategories.length > 0) {
            const yLabelValue = yAxisCategories[point.y];
            return [yLabelValue == null ? point.y : yLabelValue, point.z];
        } else {
            return [point.y, point.z];
        }
    }

    public mapDataPointsToTooltipLineItems(points: Charts_Contracts.DataPoint[]): Charts_Contracts.TooltipLineItem[] {
        if (points) {
            return points.map(point => {
                let y: string | number;
                if (typeof point.values[0] === "string") {
                    y = point.values[0];
                } else {
                    y = Number(point.values[0]).toLocaleString(navigator.language);
                }

                const z = Number(point.values[1]).toLocaleString(navigator.language);
                return {
                    text: `${point.seriesName}: (${y}, ${z})`
                };
            });
        } else {
            return [];
        }
    }
}

ChartTypesRegistry.getInstance().registerChartType({
    chartTypeName: Charts_Contracts.ChartTypesConstants.Bubble,
    constructor: BubbleChart,
    userFacingChartTypeName: Charts_Resources.ChartType_A11yLabel_Bubble
});
